const AccessKeys = {
  REVIEW_SHIFT_REPORT: 'review_shift_report',
  REVIEW_DAY_REPORT: 'review_day_report',
  MODIFY_SHIFT_REPORT: 'modify_shift_report',
  MODIFY_DAY_REPORT: 'modify_day_report',
  MANAGE_STORE: 'manage_store',
  VIEW_STORE: 'view_store',
  MANAGE_ROYALTY: 'manage_royalty',
  VIEW_ROYALTY: 'view_royalty',
};

export default AccessKeys;
